import {getImage} from '@dazn/lp-web/src/utils/commonUtils';
import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {buttonProxy} from '@dazn/lp-web/src/proxies/button.proxy';

export function articlesRailProxy(component: any): any {
    const componentType = component?.fields?.componentType;
    const title = component?.fields?.title;
    const description = component?.fields?.description;
    const tileBackgroundColor = component?.fields?.backgroundColor;
    const showGradient = component?.fields?.showGradient;
    const tiles = component?.fields?.entries?.map((entry: any) => {
        const {
            title,
            description,
            backgroundImage,
            buttons,
            logo
        } = entry?.fields ?? {};
        return {
            title,
            description,
            image: getImage(backgroundImage),
            button: buttonProxy(buttons?.[0]?.fields),
            logo: getImage(logo)
        };
    });
    return {
        title,
        description,
        componentType,
        tiles,
        tileBackgroundColor,
        railType: ComponentTypes.ARTICLES_RAIL,
        showGradient
    };
}
